/**
 * @flow
 * @relayHash c50ebe87d1bab5822a3ba80a3152722c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type notificationDeleteInput = {|
  clientMutationId?: ?string,
  id: string,
  scope?: ?string,
|};
export type removeNotificationMutationVariables = {|
  input: notificationDeleteInput
|};
export type removeNotificationMutationResponse = {|
  +notificationDelete: ?{|
    +clientMutationId: ?string
  |}
|};
export type removeNotificationMutation = {|
  variables: removeNotificationMutationVariables,
  response: removeNotificationMutationResponse,
|};
*/


/*
mutation removeNotificationMutation(
  $input: notificationDeleteInput!
) {
  notificationDelete(input: $input) {
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "notificationDeleteInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "notificationDelete",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "notificationDeletePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "removeNotificationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "removeNotificationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "removeNotificationMutation",
    "id": null,
    "text": "mutation removeNotificationMutation(\n  $input: notificationDeleteInput!\n) {\n  notificationDelete(input: $input) {\n    clientMutationId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6f4256ded5bd7db23f3b8260b966d80c';
module.exports = node;
